import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Complaints_Form.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  Create,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/process_requirement/complaint/Slice";
import {
  allNatureComplaints,
  allSampleManagement,
  AllCustomer,
  AllCustomerId,
} from "../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";

function Complaints_Form({ handleClose }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
    getValues,
    control,
  } = useForm();

  const [filePreview, setFilePreview] = useState(null);
  const fileInputRef = useRef(null);

  const dispatch = useDispatch();

  const all_nature_complaints = useSelector(
    (state) => state.common.all_nature_complaints,
  );

  const all_sample_management = useSelector(
    (state) => state.common.all_sample_management,
  );

  const all_customer = useSelector((state) => state.common.all_customer);

  useEffect(() => {
    dispatch(allNatureComplaints());
    dispatch(allSampleManagement());
    dispatch(AllCustomerId());
  }, [dispatch]);

  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("sample_management_id", data.sample_management_id);
      formData.append("nature_of_complaint_id", data.nature_of_complaint_id);

      formData.append("users_id", data.client_name_id);

      formData.append("customer_name", data.customer_name);
      formData.append("contact_person_name", data.contact_person_name);
      formData.append(
        "contact_person_contact_no",
        data.contact_person_contact_no,
      );
      formData.append("contact_person_email", data.contact_person_email);
      formData.append("remark", data.remark);

      // if (data.attach_file instanceof File) {
      formData.append("attach_file", data.image[0]);
      // }

      const res = await dispatch(Create(formData));

      if (res.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        reset();
        setFilePreview(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        setSuccess(true);
        handleClose?.();
      }
    } catch (err) {
      console.error("Submit error:", err);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setValue("attach_file", file, { shouldValidate: true });
      setFilePreview(URL.createObjectURL(file));
    }
  };

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">
          {/* Sample ID */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Sample ID</Form.Label>
              <Controller
                name="sample_management_id"
                control={control}
                rules={{ required: "Sample is required" }}
                render={({ field }) => (
                  <Select
                    options={all_sample_management}
                    value={
                      all_sample_management?.find(
                        (o) => o.value === field.value,
                      ) || null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.sample_management_id && (
                <Form.Text className="text-danger">
                  {errors.sample_management_id.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Customer ID</Form.Label>
              <Controller
                name="client_name_id"
                control={control}
                rules={{ required: "Sample is required" }}
                render={({ field }) => (
                  <Select
                    options={all_customer}
                    value={
                      all_customer?.find((o) => o.value === field.value) || null
                    }
                    onChange={(e) => {
                      field.onChange(e?.value || null);
                      setValue("customer_name", e?.customer_name);
                    }}
                  />
                )}
              />
              {errors.client_name_id && (
                <Form.Text className="text-danger">
                  {errors.client_name_id.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>
          {/* Customer Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Customer Name"
                {...register("customer_name", {
                  required: "Customer name is required",
                })}
              />
              {errors.customer_name && (
                <Form.Text className="text-danger">
                  {errors.customer_name.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Customer ID */}

          {/* Contact Person Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Contact Person Name</Form.Label>
              <Form.Control
                placeholder="Contact Person Name."
                {...register("contact_person_name", {
                  required: "Contact Person Name is required",
                })}
              />
              {errors.contact_person_name && (
                <Form.Text className="text-danger">
                  {errors.contact_person_name.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Contact No */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>(Contact Person) Contact No.</Form.Label>
              <Form.Control
                maxLength={10}
                placeholder="Enter Contact No."
                {...register("contact_person_contact_no", {
                  required: "Contact number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Alternate Contact No. must be exactly 10 digits",
                  },
                })}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
              />
              {errors.contact_person_contact_no && (
                <Form.Text className="text-danger">
                  {errors.contact_person_contact_no.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Email */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>(Contact Person) Email</Form.Label>
              <Form.Control
                placeholder="Email"
                {...register("contact_person_email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email address",
                  },
                })}
              />
              {errors.contact_person_email && (
                <Form.Text className="text-danger">
                  {errors.contact_person_email.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Nature Of Complaint */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Nature Of Complaint</Form.Label>
              <Controller
                name="nature_of_complaint_id"
                control={control}
                rules={{ required: "Nature Of Complaint is required" }}
                render={({ field }) => (
                  <Select
                    options={all_nature_complaints}
                    value={
                      all_nature_complaints?.find(
                        (o) => o.value === field.value,
                      ) || null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.nature_of_complaint_id && (
                <Form.Text className="text-danger">
                  {errors.nature_of_complaint_id.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>

          {/* Remark */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                placeholder="Remark"
                {...register("remark", {
                  required: "Remark is required",
                })}
              />
              {errors.remark && (
                <Form.Text className="text-danger">
                  {errors.remark.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Attach Document */}
          <div className="col-md-4">
            <Form.Group className="form_group file_field">
              <Form.Label>Attach Document (Optional)</Form.Label>

              <div className="absolute_fields">
                <Form.Control
                  type="file"
                  {...register("image", {
                    // required:
                    //   typeof getValues("image") === "string"
                    //     ? false
                    //     : "File is required",
                  })}
                  accept="*"
                />
                <div className="upload_icon_holder">
                  <FontAwesomeIcon icon={faUpload} />
                </div>
                {errors.image && (
                  <span className="text-danger">{errors.image.message}</span>
                )}
              </div>
              {(() => {
                const fileValue = watch("image");

                // URL for preview
                const fileUrl =
                  typeof fileValue === "string"
                    ? process.env.REACT_APP_IMG_URL + fileValue
                    : fileValue?.length > 0
                    ? URL.createObjectURL(fileValue[0])
                    : null;

                // Type detection
                const fileType =
                  typeof fileValue === "string"
                    ? fileValue.toLowerCase()
                    : fileValue?.[0]?.type;

                if (!fileUrl) return null;

                return (
                  <div className="image_holder">
                    {/* IMAGE */}
                    {(fileType?.includes("image") ||
                      fileType?.endsWith(".jpg") ||
                      fileType?.endsWith(".jpeg") ||
                      fileType?.endsWith(".png")) && (
                      <img
                        src={fileUrl}
                        alt="Preview"
                        className="image-preview"
                        // style={{ maxWidth: "100px" }}
                      />
                    )}

                    {/* PDF */}
                    {(fileType === "application/pdf" ||
                      fileType?.endsWith(".pdf")) && (
                      <iframe
                        src={fileUrl}
                        // style={{ maxWidth: "100px" }}
                        title="PDF"
                      />
                    )}

                    {/* WORD */}
                    {(fileType?.includes("word") ||
                      fileType?.endsWith(".doc") ||
                      fileType?.endsWith(".docx")) && (
                      <div>
                        <p>Word preview not supported</p>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open / Download Word File
                        </a>

                        <iframe
                          src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                          style={{ maxWidth: "100px" }}
                          title="Word Preview"
                        />
                      </div>
                    )}

                    {/* EXCEL */}
                    {(fileType?.includes("spreadsheet") ||
                      fileType?.endsWith(".xlsx") ||
                      fileType?.endsWith(".xls")) && (
                      <div>
                        <p>Excel preview not supported</p>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open / Download Excel File
                        </a>
                      </div>
                    )}
                  </div>
                );
              })()}
              {/* {filePreview && (
                <div className="image_holder">
                  <img
                    src={filePreview}
                    alt="Preview"
                    className="img_preview"
                  />
                </div>
              )} */}
            </Form.Group>
          </div>
        </div>

        {/* Buttons */}
        <div className="permission_btn_holder">
          {success ? (
            <Success_Toster successText="Save Audit Successfully!" />
          ) : (
            <>
              <Button type="button" className="permission_btn No_btn">
                Reset
              </Button>

              <Button
                type="button"
                className="permission_btn Yes_btn"
                // onClick={() => setSuccess(true)}
                onClick={handleSubmit(onSubmit)}
              >
                Save
              </Button>
            </>
          )}
        </div>
        {/* <div className="permission_btn_holder">
          <Button
            type="button"
            className="permission_btn No_btn"
            onClick={handleClose}
          >
            Reset
          </Button>

          <Button type="submit" className="permission_btn Yes_btn">
            Save
          </Button>
        </div> */}
      </div>
    </section>
  );
}

export default Complaints_Form;
